export function parseStylistOrder(raw) {
  if (!Array.isArray(raw)) {
    return [];
  }

  const seen = new Set();
  const out = [];
  for (const item of raw) {
    const id = typeof item === "string" ? Number.parseInt(item, 10) : Number(item);
    if (!Number.isInteger(id) || id <= 0 || seen.has(id)) {
      continue;
    }
    seen.add(id);
    out.push(id);
  }
  return out;
}

export function sortByStylistOrder(items, order) {
  if (!Array.isArray(items) || items.length === 0 || !order?.length) {
    return items || [];
  }

  const index = new Map(order.map((id, i) => [Number(id), i]));
  return [...items].sort((a, b) => {
    const aId = Number(a.user_id);
    const bId = Number(b.user_id);
    const ai = index.has(aId) ? index.get(aId) : order.length;
    const bi = index.has(bId) ? index.get(bId) : order.length;
    return ai - bi;
  });
}

/**
 * Apply a new order for a visible subset of stylists without dropping ids
 * that are not currently in the list (e.g. other locations).
 */
export function mergeStylistOrder(existingOrder, subsetOrder) {
  const existing = parseStylistOrder(existingOrder);
  const subset = parseStylistOrder(subsetOrder);
  if (subset.length === 0) {
    return existing;
  }
  if (existing.length === 0) {
    return subset;
  }

  const existingSet = new Set(existing);
  const subsetExisting = subset.filter((id) => existingSet.has(id));
  const extra = subset.filter((id) => !existingSet.has(id));
  const subsetSet = new Set(subsetExisting);
  const queue = [...subsetExisting];
  const result = [];

  for (const id of existing) {
    if (subsetSet.has(id)) {
      const next = queue.shift();
      if (next != null) {
        result.push(next);
      }
    } else {
      result.push(id);
    }
  }

  result.push(...queue, ...extra);
  return result;
}
